export const userQueryKeys = {
  users: ["users"],
  currentUser: ["users-me"],
  userInvites: ["user-invites"],
};
